import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const EmptyCartMessage = () => {
  const navigate = useNavigate();

  return (
    <Box textAlign="center" py={10}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Your cart is empty.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate("/shop")}>
        Return to Shop
      </Button>
    </Box>
  );
};

export default EmptyCartMessage;
